<template>
	<v-dialog v-model="dialog" :max-width="maxWidth" persistent>
		<v-card>
			<v-toolbar flat dense cad color="info" dark>
				<v-toolbar-title class="subheading text-xs-center">{{ title }}</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

			<v-card-text>
				<slot><div class="pt-3 pb-2" v-html="text"></div></slot>
				<v-textarea v-if="hasNoteField" v-model="note" auto-grow rows="3" box label="Notes"></v-textarea>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn :disabled="isConfirming" 
                    flat 
                    @click="onCancel">
                {{ cancelButtonText }}
                </v-btn>

				<v-btn :disabled="isConfirming || isDisabled"
                    :loading="isConfirming" 
                    color="primary" 
                    flat
                    @click="onConfirm">
					{{ confirmButtonText }} <span slot="loader"><v-progress-circular indeterminate size="20" width="3"/></span>
                </v-btn>

			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			dialog: {
				type: Boolean,
				required: true
			},
            title: {
                type: String,
                default: "Confirm"
            },
            text: {
                type: String,
                default: "Are you sure?"
            },
            confirmButtonText: {
                type: String,
                default: "Confirm"
            },
            cancelButtonText: {
                type: String,
                default: "Cancel"
            },
			isConfirming: {
				type: Boolean,
				required: false
			},
			hasNoteField: {
				type: Boolean,
				required: false
			},
			maxWidth: {
				type: String,
				default: "500"
			},
			isDisabled: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				note: ''
			}
		},
		methods: {
			onConfirm() {
				this.$emit('onConfirm', this.note);
			},
			onCancel() {
				this.$emit('onCancel');
			}
		}
	};
</script>